
<!--重置密码-->
<template>
  <div class="reset" style="background:#1C2550">
    <el-row>
      <div class="filter-container">
        <el-form
          ref="form"
          :model="form"
          label-width="120px"
          :rules="rules"
        >
          <el-form-item
            :label="$t('text.jmm')"
            prop="oldpwd"
          >
            <el-input
              v-model="form.oldpwd"
              type="password"
              :placeholder="$t('placeholder.jmm')"
              clearable
            />
          </el-form-item>
          <el-form-item
            :label="$t('text.xmm')"
            prop="newpwd"
          >
            <el-input
              v-model="form.newpwd"
              :placeholder="$t('placeholder.xmm')"
              type="password"
              clearable
            />
          </el-form-item>
          <el-form-item
            :label="$t('text.qrmm')"
            prop="pwdconfirm"
          >
            <el-input
              v-model="form.pwdconfirm"
              type="password"
              clearable
              :placeholder="$t('placeholder.qrmm')"
            />
          </el-form-item>
          <el-form-item>
            <el-button
              plain
              type="primary"
              style="background:#1E9585;border:none;color:#fff"
              @click="handleSubmit"
            >{{ $t('button.bc') }}</el-button>
            <!-- <el-button>重置</el-button> -->
          </el-form-item>
        </el-form>
      </div>
    </el-row>
  </div>
</template>
<script>

import { ChangeMyPwd } from '@/api/Users'

export default {
  components: {},
  data () {
    var validatePass = (rule, value, callback) => {
      if (value !== this.form.newpwd) {
        callback(new Error(this.$t('notice.mmbyz')))
      }
      callback()
    }
    return {
      form: {
        oldpwd: '',
        newpwd: '',
        pwdconfirm: ''
      },

      rules: {
        oldpwd: [
          { required: true, message: this.$t('placeholder.jmm'), trigger: 'blur' }
        ],
        newpwd: [
          { required: true, message: this.$t('placeholder.xmm'), trigger: 'blur' }
        ],
        pwdconfirm: [
          { required: true, message: this.$t('placeholder.zcsr'), trigger: 'blur' },
          { validator: validatePass, trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    // 修改我的密码（我的信息）
    handleSubmit () {
      this.$refs.form.validate((valid) => {
        if (valid) {
          ChangeMyPwd(this.form).then(() => {
            this.$message({
              message: this.$t('notice.xgcg'),
              type: 'success',
              duration: 1 * 1000
            })
          })
        } else {
          this.$message({
            type: 'warning',
            message: this.$t('notice.tgyz'),
            duration: 1 * 1000
          })
        }
      })
    }
  }
}
</script>

<style lang='stylus' scoped>
.reset
  height 100%
  .el-row
    padding: 10px
    height 100%
    text-align center
  .filter-container
    border-radius: 5px
    height: 809px
    background: #1D3666
    .el-form
     width: 35%;
     margin: auto;
     padding-top: 140px;
     >>>.el-form-item__label
      color #1CC197
     .el-input
      >>>.el-input__inner
       border: 1px solid #1CC197
       background:#1D3666
       color: #fff
      >>>.el-input__prefix
       color: #fff
</style>
